import React, { useState, useEffect } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../Constants";

const ResetPassword = () => {
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    new: false,
    confirm: false,
  });

  const [isTokenValid, setIsTokenValid] = useState(false);
  const [token, setToken] = useState("");

  useEffect(() => {
    const tokenFromURL = new URLSearchParams(window.location.search).get("token");
    setToken(tokenFromURL);

    if (!tokenFromURL) return;

    axios
      .get(`${API_URL}/api/user/reset-password?token=${tokenFromURL}`, {
        headers: { Authorization: undefined },
      })
      .then(() => setIsTokenValid(true))
      .catch(() => setIsTokenValid(false));
  }, []);

  const handleChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (passwords.newPassword !== passwords.confirmPassword) {
    toast.error("Passwords do not match");
    return;
  }

  try {
    const response = await axios.post(
      `${API_URL}/api/user/reset-password?token=${token}`,
      {
        newPassword: passwords.newPassword,
        confirmPassword: passwords.confirmPassword,
      },
      {
        headers: { Authorization: undefined },
      }
    );
      toast.success(response.data);

  } catch (err) {
    const errorMsg = err.response?.data;
    toast.error(errorMsg);
  }
};


  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-pastel-blue-100 to-pastel-pink-100">
      {isTokenValid ? (
        <motion.form
          className="relative bg-white/50 p-8 shadow-xl rounded-3xl w-full max-w-md border border-white/30"
          onSubmit={handleSubmit}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2 className="text-3xl font-extrabold mb-6 text-center text-gray-800 tracking-wider">
            Reset Password
          </h2>

          {/* New Password */}
          <div className="relative mb-4">
            <motion.input
              type={showPassword.new ? "text" : "password"}
              name="newPassword"
              placeholder="New Password"
              className="w-full p-4 bg-white/60 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pastel-blue-300 text-gray-700 placeholder-gray-500 pr-12 transition-all duration-300 ease-in-out"
              value={passwords.newPassword}
              onChange={handleChange}
              required
              whileFocus={{ scale: 1.02 }}
            />
            <div
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
              onClick={() =>
                setShowPassword({ ...showPassword, new: !showPassword.new })
              }
            >
              {showPassword.new ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
            </div>
          </div>

          {/* Confirm Password */}
          <div className="relative mb-6">
            <motion.input
              type={showPassword.confirm ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm Password"
              className="w-full p-4 bg-white/60 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pastel-pink-300 text-gray-700 placeholder-gray-500 pr-12 transition-all duration-300 ease-in-out"
              value={passwords.confirmPassword}
              onChange={handleChange}
              required
              whileFocus={{ scale: 1.02 }}
            />
            <div
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
              onClick={() =>
                setShowPassword({
                  ...showPassword,
                  confirm: !showPassword.confirm,
                })
              }
            >
              {showPassword.confirm ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
            </div>
          </div>

          <motion.button
            type="submit"
            className="w-full bg-gradient-to-r from-pastel-blue-400 to-pastel-pink-400 text-white p-4 rounded-xl font-bold shadow-md hover:shadow-lg transition-transform duration-300 ease-in-out hover:scale-105"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Reset Password
          </motion.button>
        </motion.form>
      ) : (
        <div className="text-center text-red-600 font-bold text-xl">
          Invalid or expired token.
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </div>
  );
};

export default ResetPassword;
